module.exports = __webpack_public_path__ + "img/sec-12-kyobo.9e14bd6e.svg";